// Firebase App Distribution API Types
// Based on Service: firebaseappdistribution.googleapis.com

export enum AppPlatform {
  IOS = 'ios',
  ANDROID = 'android',
}

export interface AppDistributionRelease {
  // The name of the release resource. Format: projects/{project_number}/apps/{app_id}/releases/{release_id}
  name: string;

  // The short name of the release
  releaseNotes?: {
    text: string;
  };

  // The display version of the release
  displayVersion: string;

  // The build version of the release
  buildVersion: string;

  // The time the release was created
  createTime: string;

  // The download URL for the release
  downloadUrl?: string;

  // The Firebase console URI for the release
  firebaseConsoleUri?: string;

  // The testing URI for the release
  testingUri?: string;

  // The binary download URI for the release
  binaryDownloadUri?: string;
}

export interface ListReleasesResponse {
  // The releases
  releases: AppDistributionRelease[];

  // A token to retrieve the next page of releases
  nextPageToken?: string;

  // Total count of releases (if available)
  totalSize?: number;
}

export interface GetReleaseRequest {
  // The release ID
  releaseId: string;

  // The platform (ios or android)
  platform: AppPlatform;
}

export interface ListReleasesRequest {
  // The platform to filter by
  platform: AppPlatform;

  // Token for pagination
  nextPageToken?: string;
}

// Local UI state types
export interface AppReleasesState {
  releases: AppDistributionRelease[];
  loading: boolean;
  error: string | null;
  nextPageToken: string | null;
  hasMore: boolean;
  platform: AppPlatform;
  selectedRelease: AppDistributionRelease | null;
}

export interface ReleaseCardProps {
  release: AppDistributionRelease;
  onViewDetails: (release: AppDistributionRelease) => void;
  onDownload: (url: string, type: 'binary' | 'firebase') => void;
}

export interface PlatformSelectorProps {
  currentPlatform: AppPlatform;
  onPlatformChange: (platform: AppPlatform) => void;
  disabled?: boolean;
}

export interface ReleaseDetailsModalProps {
  release: AppDistributionRelease | null;
  isOpen: boolean;
  onClose: () => void;
}
